import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import es from "../i18n/es.json";

export const resources = {
    es: {
     common: es
    },
} as const;

i18n.use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "es",
        ns: ["common"],
        defaultNS: "common",
        resources,
        debug: false,
        detection: {
            order: ["querystring", "cookie", "localStorage", "navigator"],
            lookupQuerystring: "lng",
            lookupCookie: "i18next",
            lookupLocalStorage: "i18nextLng",
            caches: ["localStorage", "cookie"],
        },
    });

export default i18n;
